module.exports = __webpack_public_path__ + "static/media/u35_1.54b0a91a.mp3";